import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { apiKey, getDefaultConfig } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { Editor } from '@tinymce/tinymce-react';
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const ProjectReportSlice = _ref => {
  let {
    index,
    slice,
    handleTinyMce,
    handleSliceChange,
    handleSubmit,
    pageAccess,
    isDisabled,
    showClientVisibilityCheckbox
  } = _ref;
  const {
    id,
    title,
    description,
    tab
  } = slice;
  const canEditTextBody = pageAccess.canEditProjectDetails || tab === 'activity' && pageAccess.canEditProjectActivity;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, (showClientVisibilityCheckbox || tab === 'narrative') && /*#__PURE__*/React.createElement(Form.Group, {
    as: Row,
    className: "pb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, showClientVisibilityCheckbox && /*#__PURE__*/React.createElement(Row, {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t("visible_to_client")), /*#__PURE__*/React.createElement(Col, {
    md: 11
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    disabled: !pageAccess.canEditProjectDetails || isDisabled,
    as: Form.Check,
    object: slice,
    name: "visible_to_client",
    onChange: e => handleSliceChange(e, id, true)
  }))), tab === 'narrative' && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, t("include_in_rnd_report")), /*#__PURE__*/React.createElement(Col, {
    md: 8,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    disabled: !pageAccess.canEditProjectDetails || isDisabled,
    as: Form.Check,
    object: slice,
    name: "include_in_rnd_report",
    onChange: e => handleSliceChange(e, id, true)
  }))))), /*#__PURE__*/React.createElement(Form.Group, {
    as: Row,
    className: "pt-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-primary"
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails || isDisabled,
    as: Form.Control,
    object: slice,
    onBlur: handleSubmit,
    controlAs: "textarea",
    rows: "2",
    name: "label",
    onChange: e => handleSliceChange(e, id)
  })), tab === 'narrative' && /*#__PURE__*/React.createElement("p", null, description)), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !canEditTextBody || isDisabled,
    as: Editor,
    apiKey: apiKey,
    onBlur: handleSubmit,
    onEditorChange: e => handleTinyMce(e, title, id),
    object: slice,
    init: getDefaultConfig({
      stylesFormatterToggleIniitialValue: true,
      modules: {
        styles_formatter: true
      }
    }),
    name: "body"
  }))), /*#__PURE__*/React.createElement("hr", null));
};
export default ProjectReportSlice;